(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deals-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStrip(root) {
    var track = root.querySelector('[data-deals-track]');
    var prev = root.querySelector('[data-deals-prev]');
    var next = root.querySelector('[data-deals-next]');
    if (!track || !prev || !next || track.dataset.dealsInit === '1') return;
    track.dataset.dealsInit = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function stepSize() {
      var item = track.querySelector('.deals-strip__item');
      var gap = 16;
      var width = item ? item.getBoundingClientRect().width : track.clientWidth * 0.4;
      return (width + gap) * 2;
    }

    function go(dir) {
      track.scrollBy({
        left: dir * stepSize(),
        behavior: reduce.matches ? 'auto' : 'smooth'
      });
    }

    function sync() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }

    function queueSync() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(sync);
      }
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync);
    sync();
  }

  function initAll() {
    var strips = document.querySelectorAll('[data-deals-strip]');
    for (var i = 0; i < strips.length; i++) {
      initStrip(strips[i]);
    }
  }

  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  'use strict';

  function closeAllNav(except) {
    var openItems = document.querySelectorAll('[data-nav-parent].is-open');
    Array.prototype.forEach.call(openItems, function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var btn = item.querySelector('[data-nav-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-nav-toggle]');
    if (toggle) {
      var item = toggle.closest('[data-nav-parent]');
      if (!item) return;
      var willOpen = !item.classList.contains('is-open');
      closeAllNav(item);
      item.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
    if (!event.target.closest('[data-nav-parent]')) {
      closeAllNav(null);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-nav-parent].is-open');
    if (open) {
      var btn = open.querySelector('[data-nav-toggle]');
      closeAllNav(null);
      if (btn) btn.focus();
    }
  });

  document.addEventListener('wbtc:cart:updated', function (event) {
    var count = event.detail && typeof event.detail.item_count === 'number' ? event.detail.item_count : null;
    if (count === null) return;
    var badges = document.querySelectorAll('[data-cart-count]');
    Array.prototype.forEach.call(badges, function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var imgs = [];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ticking = false;

  function update() {
    ticking = false;
    if (!imgs.length) return;
    if (reduce.matches) {
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.transform = '';
      }
      return;
    }
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    for (var j = 0; j < imgs.length; j++) {
      var frame = imgs[j].parentElement;
      if (!frame) continue;
      var box = frame.getBoundingClientRect();
      var center = box.top + box.height / 2;
      var progress = (center - vh / 2) / (vh / 2);
      if (progress > 1) progress = 1;
      if (progress < -1) progress = -1;
      imgs[j].style.transform = 'translate3d(0, ' + (progress * -24).toFixed(1) + 'px, 0)';
    }
  }

  function queueUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function collect() {
    imgs = Array.prototype.slice.call(
      document.querySelectorAll('[data-hero-parallax] .hero__img')
    );
    queueUpdate();
  }

  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', queueUpdate);
  if (typeof reduce.addEventListener === 'function') {
    reduce.addEventListener('change', queueUpdate);
  }
  document.addEventListener('shopify:section:load', collect);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  'use strict';

  var pending = false;

  function getSection(node) {
    return node.closest('[data-cart-section]');
  }

  function dispatchCount(count) {
    document.dispatchEvent(
      new CustomEvent('wbtc:cart:updated', { detail: { item_count: count } })
    );
  }

  function changeLine(section, line, quantity, delta) {
    if (pending) return;
    pending = true;
    section.classList.add('is-updating');

    var current = parseInt(section.getAttribute('data-cart-line-count'), 10) || 0;
    var optimistic = current + delta;
    if (optimistic < 0) optimistic = 0;
    dispatchCount(optimistic);

    var url = section.getAttribute('data-cart-change-url') + '.js';
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart change failed');
        return response.json();
      })
      .then(function (cart) {
        dispatchCount(cart.item_count);
        window.location.reload();
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function lineNumber(row) {
    return parseInt(row.getAttribute('data-cart-line'), 10);
  }

  function originalQty(input) {
    return parseInt(input.getAttribute('data-original-qty'), 10) || 0;
  }

  document.addEventListener('click', function (event) {
    var stepper = event.target.closest('[data-cart-qty-minus], [data-cart-qty-plus]');
    if (stepper) {
      var section = getSection(stepper);
      if (!section) return;
      var row = stepper.closest('[data-cart-line]');
      var input = row.querySelector('[data-cart-qty-input]');
      var qty = parseInt(input.value, 10);
      if (isNaN(qty)) qty = originalQty(input);
      var next = stepper.hasAttribute('data-cart-qty-minus') ? qty - 1 : qty + 1;
      if (next < 0) next = 0;
      input.value = next;
      changeLine(section, lineNumber(row), next, next - originalQty(input));
      return;
    }

    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      var removeSection = getSection(remove);
      if (!removeSection) return;
      event.preventDefault();
      var removeRow = remove.closest('[data-cart-line]');
      var removeInput = removeRow.querySelector('[data-cart-qty-input]');
      changeLine(removeSection, lineNumber(removeRow), 0, -originalQty(removeInput));
    }
  });

  /* Personalized gift card: the $2.00 add-on product is added to or removed from
     the cart by the checkbox; the message rides along as a line item property so
     it prints on the packing slip.

     No page reload on toggle -- the write goes through the cart AJAX API and the
     page is patched in place. Reloading threw away whatever the shopper had
     already typed and made the tick box feel broken. */
  var GIFT_HANDLE = 'personalized-gift-card';
  var giftTimer = null;
  var giftDirty = false;
  var giftBusy = false;

  function giftBlock() {
    return document.querySelector('[data-gift-block]');
  }

  function giftCount() {
    var block = giftBlock();
    if (!block) return;
    var area = block.querySelector('[data-gift-message]');
    var out = block.querySelector('[data-gift-count]');
    if (area && out) out.textContent = area.value.length;
  }

  function giftLineOf(cart) {
    var line = 0;
    (cart.items || []).forEach(function (it, i) {
      if (it.handle === GIFT_HANDLE) { line = i + 1; }
    });
    return line;
  }

  function giftQtyOf(cart) {
    var qty = 0;
    (cart.items || []).forEach(function (it) {
      if (it.handle === GIFT_HANDLE) { qty = it.quantity; }
    });
    return qty;
  }

  /* Repaint everything on the page that carries the total. The add-on is not
     case-eligible, so the 12-bottle progress block cannot move and is left alone. */
  function repaintCart(cart) {
    var money = cart.total_price;
    var els = document.querySelectorAll('[data-cart-total]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = formatMoney(money);
    }
    dispatchCount(cart.item_count - giftQtyOf(cart));
  }

  /* The theme prints money server side; mirror that format here rather than
     guessing at a locale. Whole cents, two decimals, thousands separated. */
  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US',
      { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function saveGiftMessage(then) {
    var block = giftBlock();
    if (!block) return then && then();
    var line = parseInt(block.getAttribute('data-gift-line'), 10) || 0;
    var area = block.querySelector('[data-gift-message]');
    if (!line || !area) return then && then();
    giftDirty = false;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: 1,
        properties: { 'Card message': area.value }
      })
    })
      .then(function () { then && then(); })
      .catch(function () { then && then(); });
  }

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-gift-toggle]');
    if (!toggle) return;
    var block = giftBlock();
    if (!block) return;
    if (giftBusy) { toggle.checked = !toggle.checked; return; }
    giftBusy = true;
    toggle.disabled = true;
    block.classList.add('is-saving');

    var body = block.querySelector('[data-gift-body]');
    var area = block.querySelector('[data-gift-message]');
    var line = parseInt(block.getAttribute('data-gift-line'), 10) || 0;
    var wanted = toggle.checked;
    if (body) body.hidden = !wanted;

    var request = wanted
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(block.getAttribute('data-gift-variant'), 10),
              quantity: 1,
              properties: { 'Card message': area ? area.value : '' }
            }]
          })
        })
      : fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        });

    request
      .then(function () { return getCart(); })
      .then(function (cart) {
        block.setAttribute('data-gift-line', giftLineOf(cart));
        repaintCart(cart);
        if (wanted && area) { try { area.focus(); } catch (e) {} }
      })
      .catch(function () {
        /* Put the box back where the cart actually is. */
        toggle.checked = !wanted;
        if (body) body.hidden = wanted;
      })
      .then(function () {
        giftBusy = false;
        toggle.disabled = false;
        block.classList.remove('is-saving');
      });
  });

  document.addEventListener('input', function (event) {
    if (!event.target.closest('[data-gift-message]')) return;
    giftCount();
    giftDirty = true;
    clearTimeout(giftTimer);
    giftTimer = setTimeout(saveGiftMessage, 700);
  });

  /* Don't let a half-typed message get left behind by a fast checkout click. */
  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('button[name="checkout"]');
    if (!checkout || !giftDirty) return;
    event.preventDefault();
    clearTimeout(giftTimer);
    saveGiftMessage(function () { checkout.click(); });
  }, true);

  document.addEventListener('DOMContentLoaded', giftCount);
  giftCount();

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var section = getSection(input);
    if (!section) return;
    var row = input.closest('[data-cart-line]');
    var next = parseInt(input.value, 10);
    if (isNaN(next) || next < 0) next = 0;
    input.value = next;
    if (next === originalQty(input)) return;
    changeLine(section, lineNumber(row), next, next - originalQty(input));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  'use strict';

  function hydrate(root) {
    if (!root || root.dataset.performed === 'true' || root.dataset.loaded === 'true') return;
    var url = root.dataset.url;
    if (!url) return;

    function load() {
      if (root.dataset.loaded === 'true') return;
      root.dataset.loaded = 'true';
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-related-products]');
          if (fresh && fresh.innerHTML.trim().length) {
            root.innerHTML = fresh.innerHTML;
            root.querySelectorAll('.reveal').forEach(function (el) {
              el.classList.add('is-in');
            });
          }
        })
        .catch(function () {
          root.dataset.loaded = 'false';
        });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            load();
          }
        });
      }, { rootMargin: '400px 0px' });
      observer.observe(root);
    } else {
      load();
    }
  }

  document.querySelectorAll('[data-related-products]').forEach(hydrate);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-related-products]');
    if (root) hydrate(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
